import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import Reveal, { SectionLabel } from "./Reveal";

const FAQS = [
  [
    "Preciso de encaminhamento pra marcar?",
    "Não precisa. Você pode agendar direto comigo pelo WhatsApp. Se já tiver um pedido ou relatório de outro médico, pode trazer, ele ajuda na consulta.",
  ],
  [
    "Quanto tempo dura a primeira consulta?",
    "A primeira consulta é mais longa porque eu quero ouvir sua história completa, sem pressa. Costuma durar cerca de uma hora e meia.",
  ],
  [
    "Posso levar meus exames anteriores?",
    "Não só pode, como deve! Exames, laudos, receitas e a lista de remédios que você usa me ajudam a entender seu histórico. Se não tiver nada em mãos, não tem problema, a gente começa pela conversa.",
  ],
  ["Atende por plano de saúde ou só particular?", "Somente particular."],
  ["Como funciona o retorno?", "Você tem até 30 dias para fazer o seu retorno."],
  [
    "Atende online?",
    "Para a realização do atendimento online, primeiro é necessário uma avaliação, onde eu consigo analisar o seu caso e dizer se pode ou não ser online.",
  ],
];

export default function FAQ() {
  return (
    <section id="faq" className="bg-cream py-28 md:py-36">
      <div className="mx-auto max-w-[1240px] px-5 md:px-10">
        <SectionLabel n="07">Dúvidas frequentes</SectionLabel>
        <Reveal delay={0.08}>
          <h2 className="mt-8 font-display font-medium text-[clamp(2.1rem,4.2vw,3.6rem)] leading-[1.08] tracking-[-0.01em]">
            Perguntas <em className="font-serifd italic text-terra">frequentes</em>
          </h2>
        </Reveal>

        <Reveal delay={0.16}>
          <Accordion
            type="single"
            collapsible
            className="mt-12 max-w-4xl"
            data-testid="faq-accordion"
          >
            {FAQS.map(([q, a], i) => (
              <AccordionItem key={q} value={`item-${i}`} className="border-olive/20">
                <AccordionTrigger
                  data-testid={`faq-trigger-${i + 1}`}
                  className="py-6 text-left font-display text-lg md:text-2xl font-medium text-olive hover:no-underline hover:text-terra [&[data-state=open]]:text-terra"
                >
                  {q}
                </AccordionTrigger>
                <AccordionContent className="pb-6 text-base md:text-lg leading-relaxed text-olive/75">
                  {a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
